export default "__VITE_ASSET__DxVJVS83__"